import script from "./ExportWarningModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ExportWarningModal.vue?vue&type=script&setup=true&lang=js"

import "./ExportWarningModal.vue?vue&type=style&index=0&id=1b2e2f72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b2e2f72"]])

export default __exports__